import { createContext } from 'react';
export var currentSecondaryDimensionIndexContext = createContext(0);
